module.exports = __webpack_public_path__ + "img/whoAreYou.ceefed90.png";